"use strict";

exports.__esModule = true;
exports.Config = void 0;
const Config = exports.Config = {
  make: ({
    livePreview = Config.makeLivePreview()
  } = {}) => ({
    livePreview
  }),
  makeLivePreview: ({
    enabled = false,
    updatedComponentIds = [],
    dataIsInvalidated = false
  } = {}) => ({
    enabled,
    updatedComponentIds,
    dataIsInvalidated
  }),
  isLivePreviewEnabled: config => config.livePreview.enabled,
  getUpdatedComponents: (config, components) => {
    const {
      livePreview: {
        enabled,
        updatedComponentIds
      }
    } = config;
    const uniqueUpdatedComponentIds = new Set(updatedComponentIds);
    const updatedComponents = enabled && updatedComponentIds.length ? components.filter(({
      id
    }) => uniqueUpdatedComponentIds.has(id)) : components;
    return updatedComponents;
  }
};
//# sourceMappingURL=config.js.map